import { createTypes } from "../../utils/helpers";

const CALIBRATION_PROFILES_FETCH_ENTITIES: any = createTypes(
    'CALIBRATION_PROFILES_FETCH_CALIBRATION_PROFILES',
);
export {CALIBRATION_PROFILES_FETCH_ENTITIES};
